import { render } from "./SeedsView.vue?vue&type=template&id=4afd3d9a&scoped=true"
import script from "./SeedsView.vue?vue&type=script&lang=js"
export * from "./SeedsView.vue?vue&type=script&lang=js"

import "./SeedsView.vue?vue&type=style&index=0&id=4afd3d9a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src794593303/src/git-codecommit.us-west-2.amazonaws.com/v1/repos/viracocha-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afd3d9a"]])

export default __exports__